import { useQuery, keepPreviousData } from '@tanstack/react-query';
import HomeServices from '../pages/home/homeService/HomeService';
import OutletService from '../pages/outlet/outletService/OutletService';
import HeaderProductCategories from '../layouts/Header/headerServices/HeaderServices';

// Home səhifəsi üçün query hooks
export const useCampaigns = (selectedLanguage?: string | null) => {
  return useQuery({
    queryKey: ['campaigns', selectedLanguage],
    queryFn: async () => {
      const res = await HomeServices.CampaignData();
      return res;
    },
    enabled: true,
    staleTime: 5 * 60 * 1000, // 5 dəqiqə
  });
};

export const useOfferWeek = (selectedLanguage?: string | null) => {
  return useQuery({
    queryKey: ['offerWeek', selectedLanguage],
    queryFn: async () => {
      // Disabled: /weekly-picks returns 404 from backend
      return { data: [] };
    },
    enabled: false,
    staleTime: 5 * 60 * 1000,
  });
};

export const useMostSeller = (selectedLanguage?: string | null) => {
  return useQuery({
    queryKey: ['mostSeller', selectedLanguage],
    queryFn: async () => {
      const res = await HomeServices.MostSellerData();
      return res;
    },
    enabled: true,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
};

export const useSelectedServices = (selectedLanguage?: string | null) => {
  return useQuery({
    queryKey: ['selectedServices', selectedLanguage],
    queryFn: async () => {
      const res = await HomeServices.selectedServices();
      return res;
    },
    enabled: true,
    staleTime: 5 * 60 * 1000,
  });
};

export const useOfficialServices = () => {
  return useQuery({
    queryKey: ['officialServices'],
    queryFn: async () => {
      const res = await HomeServices.getPartnors();
      return res;
    },
    enabled: true,
    staleTime: 10 * 60 * 1000, // 10 dəqiqə
  });
};
export const useOutletHero = () => {
  return useQuery({
    queryKey: ['outletHero'],
    queryFn: async () => {
      const res = await OutletService.getOutletHero();
      return res;
    },
    enabled: true,
    staleTime: 10 * 60 * 1000, // 10 dəqiqə
  });
};
export const useHomeHero = () => {
  return useQuery({
    queryKey: ['homeHero'],
    queryFn: async () => {
      const res = await HomeServices.getHomeHero();
      return res;
    },
    enabled: true,
    staleTime: 10 * 60 * 1000, // 10 dəqiqə
  });
};
export const useHomeHeroFeatures:any = () => {
  return useQuery({
    queryKey: ['homeHeroFeatures'],
    queryFn: async ():Promise<useHomeHeroFeaturesData> => {
      const res = await HomeServices.getHomeHeroFeatures();
      return res;
    },
    enabled: true,
    staleTime: 10 * 60 * 1000, // 10 dəqiqə
  });
};

export interface useHomeHeroFeaturesData {
  data: HeroFeature[];
}

export interface HeroFeature {
  id: number;
  image: string;
  title: string;
  sort_order: number;
}

export const useHeaderCategories = (selectedLanguage?: string | null) => {
  return useQuery({
    queryKey: ['headerCategories', 'az'],
    queryFn: async () => {
      const res = await HeaderProductCategories.AllHeaderProductCategories("az");
      let list = res?.data?.data || res?.data || [];
      if (!Array.isArray(list) || list.length === 0) {
        const orderCatRes = await HeaderProductCategories.getOrderCategory("az");
        list = orderCatRes?.data?.data || orderCatRes?.data || [];
      }
      return Array.isArray(list) ? list : [];
    },
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

export const useCategoryProducts = (
  categoryId: number | string | null,
  selectedLanguage?: string | null,
  channel: string = "1688",
  perPage: number = 24
) => {
  return useQuery({
    queryKey: ['categoryProducts', categoryId !== null && categoryId !== undefined ? String(categoryId) : null, selectedLanguage, channel, perPage],
    queryFn: async () => {
      if (!categoryId) return null;
      const res = await HeaderProductCategories.getPartnerProducts({
        category_id: categoryId,
        channel: channel || "1688",
        page: 1,
        per_page: perPage,
      });
      return res?.data;
    },
    enabled: categoryId !== null && categoryId !== undefined && categoryId !== '',
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

export const usePopularProducts = (
  selectedLanguage?: string | null,
  page: number = 1,
  perPage: number = 24
) => {
  return useQuery({
    queryKey: ['popularProducts', selectedLanguage, page, perPage],
    queryFn: async () => {
      const res = await HomeServices.getPopularProducts({
        page,
        per_page: perPage,
      });
      return res;
    },
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });
};

